import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "custom-header-container" }
const _hoisted_2 = { class: "menu-title" }
const _hoisted_3 = { class: "location-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "cat-name-menu" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "produc-cat" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "label-form" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Location", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "label-form" }, "Categories", -1)
const _hoisted_12 = { class: "label-form" }
const _hoisted_13 = { class: "label-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LbrxLoaderSpinner = _resolveComponent("LbrxLoaderSpinner")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_caret_right_outlined = _resolveComponent("caret-right-outlined")!
  const _component_EnvironmentOutlined = _resolveComponent("EnvironmentOutlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_LbrxLoaderSpinner, {
        "is-loaded": !_ctx.loading
      }, null, 8, ["is-loaded"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_breadcrumb, { style: {"margin":"16px 0"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/'))),
            class: "breadcrumb-icon"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Pos.Dashboard")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Pos.Menu")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 16},
          lg: { span: 16 },
          xl: { span: 16 },
          xxl: { span: 16 },
          class: "search-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              class: "search-input",
              placeholder: _ctx.t('Pos.searchDish')
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_SearchOutlined, { class: "search-icon" })
              ]),
              _: 1
            }, 8, ["placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 8},
          lg: { span: 8 },
          xl: { span: 8 },
          xxl: { span: 8 },
          class: "add-btn-container"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "collapse-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_collapse, {
              activeKey: _ctx.activeKey,
              "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
              bordered: false,
              class: "collapse-container"
            }, {
              expandIcon: _withCtx(({ isActive }) => [
                _createVNode(_component_caret_right_outlined, {
                  rotate: isActive ? 90 : 0
                }, null, 8, ["rotate"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, { class: "menu-collapse" }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.menu.name), 1),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_tag, { color: "green" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EnvironmentOutlined),
                            _createTextVNode(" " + _toDisplayString(_ctx.menu.locationName), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_DeleteOutlined, {
                            class: "delete-icon",
                            onClick: _ctx.showDeletePopup
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { class: "cat-container" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, {
                          xs: { span: 24},
                          sm: { span: 24},
                          md: {span: 24},
                          lg: { span: 24 },
                          xl: { span: 24 },
                          xxl: { span: 24 },
                          class: "categories-wrapper"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.categories, (cat) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: cat.id,
                                class: "category-item",
                                onClick: ($event: any) => (_ctx.toggleCategory(cat.menu_category_id, cat.name))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(cat.name), 1)
                              ], 8, _hoisted_4))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.categories, (item) => {
                      return (_openBlock(), _createBlock(_component_a_row, {
                        class: "new-dish-container",
                        key: item
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: { span: 24},
                            sm: { span: 24},
                            md: {span: 24},
                            lg: { span: 24 },
                            xl: { span: 24 },
                            xxl: { span: 24 }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    class: "new-dish-btn",
                                    onClick: ($event: any) => (_ctx.openAddDish(item.menu_category_id))
                                  }, [
                                    _createVNode(_component_PlusCircleOutlined, { class: "plus-icon" }),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("Pos.AddNewDish")), 1)
                                  ], 8, _hoisted_6),
                                  _createElementVNode("div", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.products, (product) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: product.id,
                                        class: "product-card"
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(product.name), 1),
                                        _createElementVNode("img", {
                                          src: product.photo
                                        }, null, 8, _hoisted_8)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      open: _ctx.openAdd,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openAdd) = $event)),
      class: "custom-class",
      "root-class-name": "root-class-name",
      placement: _ctx.locale === 'ar' ? 'left' : 'right',
      width: _ctx.modalWidth,
      onClose: _ctx.resetFormAdd
    }, {
      title: _withCtx(() => [
        _createElementVNode("p", {
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
        }, " Add menu ", 2)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.add
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("Pos.Add")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              danger: "",
              onClick: _ctx.resetFormAdd
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("Pos.Cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "addFormRef",
          model: _ctx.addForm,
          rules: _ctx.rules,
          layout: "vertical",
          class: _normalizeClass({ 'is-rtl': _ctx.textDirection === 'rtl' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "name" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Pos.Name')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.addForm.name,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addForm.name) = $event)),
                          placeholder: _ctx.t('Pos.Name'),
                          class: "input-form"
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "location_id" }, {
                      label: _withCtx(() => [
                        _hoisted_10
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.addForm.location_id,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addForm.location_id) = $event)),
                          "show-search": "",
                          "option-filter-prop": 'label'
                        }, {
                          notFoundContent: _withCtx(() => [
                            _createVNode(_component_a_empty, {
                              description: _ctx.t('Pos.NoData'),
                              image: _ctx.simpleImage
                            }, null, 8, ["description", "image"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.locations, (location) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                label: location.name,
                                key: location.id,
                                value: location.id,
                                selected: location.id === _ctx.addForm.location_id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(location.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value", "selected"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "categories" }, {
                      label: _withCtx(() => [
                        _hoisted_11
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.state.categoryValue,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.categoryValue) = $event)),
                          mode: "multiple",
                          "label-in-value": "",
                          placeholder: "Fetch category",
                          style: {"width":"100%"},
                          "filter-option": false,
                          "not-found-content": _ctx.state.fetchingCat ? undefined : null,
                          options: _ctx.state.catOptions,
                          onSearch: _ctx.fetchCategory,
                          onChange: _ctx.handleCatSelect
                        }, _createSlots({ _: 2 }, [
                          (_ctx.state.fetchingCat)
                            ? {
                                name: "notFoundContent",
                                fn: _withCtx(() => [
                                  _createVNode(_component_a_spin, { size: "small" })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["value", "not-found-content", "options", "onSearch", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "class"])
      ]),
      _: 1
    }, 8, ["open", "placement", "width", "onClose"]),
    _createVNode(_component_a_modal, {
      open: _ctx.addDish,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addDish) = $event)),
      onCancel: _ctx.resetDishFields
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Add a new dish ")
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _ctx.addDishProduct
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('Pos.Add')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.resetDishFields
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('Pos.Cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "dishFormRef",
          model: _ctx.dishForm,
          rules: _ctx.dishRules,
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "product" }, {
                      label: _withCtx(() => [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.t('Pos.Product')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.state.product,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.product) = $event)),
                          "show-search": "",
                          "default-active-first-option": false,
                          "filter-option": false,
                          onSearch: _ctx.fetchProduct,
                          options: _ctx.state.products,
                          onSelect: _ctx.selecetProduct,
                          class: "store-select"
                        }, _createSlots({ _: 2 }, [
                          (_ctx.state.fetchProduct)
                            ? {
                                name: "notFoundContent",
                                fn: _withCtx(() => [
                                  _createVNode(_component_a_spin, { size: "small" })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["value", "onSearch", "options", "onSelect"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "product_price" }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t("Pos.Price")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: !_ctx.state.product,
                          value: _ctx.dishForm.product_price,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dishForm.product_price) = $event)),
                          placeholder: _ctx.t('Pos.Price'),
                          class: "input-form"
                        }, null, 8, ["disabled", "value", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["open", "onCancel"])
  ], 64))
}